var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNikeBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nike",
    width: 200,
    height: 150,
    x: 0,
    y: 0,
    fill: "#353535",
    viewBox: "-100 -114 400 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "nike_1_",
    d: "M-5.801,84.342c-8.089-0.32-14.709-2.535-19.884-6.646c-0.987-0.785-3.341-3.14-4.13-4.134 c-2.099-2.638-3.525-5.207-4.478-8.056c-2.929-8.771-1.42-20.281,4.31-32.914c4.908-10.814,12.481-21.539,25.694-36.394 c1.945-2.186,7.742-8.579,7.778-8.579c0.015,0-0.3,0.548-0.698,1.215C-0.645-5.413-3.584,1.366-5.186,7.232 c-2.572,9.417-2.262,17.495,0.909,23.761c2.187,4.316,5.937,8.055,10.153,10.122c7.382,3.617,18.189,3.916,31.388,0.875 c0.909-0.21,45.936-12.163,100.062-26.563c54.124-14.4,98.417-26.174,98.424-26.163c0.015,0.012-125.749,53.829-191.035,81.747 c-10.34,4.42-13.105,5.536-17.964,7.243C14.325,82.617,3.195,84.699-5.801,84.342z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNikeBlack);
export default __webpack_public_path__ + "static/media/nike_black.3880bf785ab59fafcca1c7544ca23b5e.svg";
export { ForwardRef as ReactComponent };